import styled, { css } from 'styled-components';

import { HEX } from "../../Styles/LegacyColors";
import { commonResets } from "../../Styles/Utils";

// TO DO: Align and extract these to theme. (WP-254)
// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)

export const FormBoxWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "FormBoxstyles__FormBoxWrapper", componentId: "sc-15poxw6-0" })(["", " & *,&:before,&:after,& *:before,& *:after{", "}position:relative;margin-bottom:15px;"],
commonResets,





commonResets);






export const FormBoxBox = /*#__PURE__*/styled.label.withConfig({ displayName: "FormBoxstyles__FormBoxBox", componentId: "sc-15poxw6-1" })(["display:block;height:60px;width:100%;position:relative;border-bottom:2px solid ", ";transition:border 0.2s ease;", " ", " ", " ", ""],









HEX.grey,


(props) =>
props.autoHeight &&
css(["height:auto;"]),



(props) =>
props.active &&
css(["border-color:", ";"],
HEX.blue),


(props) =>
props.error &&
css(["border-color:", ";"],
HEX.purple),


(props) =>
props.noBorder &&
css(["border:none;"]));




export const FormBoxInputBox = /*#__PURE__*/styled.div.withConfig({ displayName: "FormBoxstyles__FormBoxInputBox", componentId: "sc-15poxw6-2" })(["width:100%;height:100%;input{width:100%;height:100%;padding:15px 0 0;color:", ";font-size:16px;line-height:1.35;font-weight:300;background:transparent;position:relative;border:none;outline:none;transition:color 0.2s ease;}select{width:100%;height:100%;padding:15px 0 0;color:", ";font-size:16px;line-height:1.35;font-weight:300;background:transparent;position:relative;border:none;outline:none;transition:color 0.2s ease;appearance:none;}textarea{width:100%;height:100%;padding:30px 0 15px;box-sizing:border-box;color:", ";font-size:16px;line-height:1.35;font-weight:300;background:transparent;position:relative;border:none;outline:none;transition:color 0.2s ease;display:block;resize:none;}input[type='checkbox']{width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;opacity:0;cursor:pointer;}", " ", ""],










HEX.darkGrey,














HEX.darkGrey,

















HEX.darkGrey,























(props) =>
props.autoHeight &&
css(["height:auto;"]),



(props) =>
props.active &&
css(["input,select,textarea{color:", ";}"],



HEX.blue));




export const FormBoxLabel = /*#__PURE__*/styled.div.withConfig({ displayName: "FormBoxstyles__FormBoxLabel", componentId: "sc-15poxw6-3" })(["position:absolute;font-size:16px;line-height:1;font-weight:300;height:60px;display:flex;color:", ";align-items:center;transition:all 0.2s cubic-bezier(0.13,0.6,0.43,0.92);", ""],






HEX.darkGrey,



(props) =>
props.active &&
css(["height:24px;font-size:14px;color:", ";"],


HEX.blue));



export const FormBoxError = /*#__PURE__*/styled.div.withConfig({ displayName: "FormBoxstyles__FormBoxError", componentId: "sc-15poxw6-4" })(["font-weight:300;margin-top:5px;font-size:14px;line-height:1.35;color:", ";"],




HEX.purple);